import { useGretaAIChatContext } from '../../GretaAIChat.hooks'
import {
  getIsGretaAIChatDeleteAction,
  getIsGretaAIChatRenameAction,
} from '../../GretaAIChat.utils'
import { GretaAIChatDeleteConfirmation } from '../../GretaAIChatDeleteConfirmation'
import { GretaAIChatRenameModal } from '../../GretaAIChatRenameModal'

function GretaAIChatPanelChatAction() {
  const { actions, panel } = useGretaAIChatContext()

  const { chatAction } = panel

  const { onCloseChatAction, onConfirmDeleteChat, onConfirmRenameChat } =
    actions

  const isRenameAction = getIsGretaAIChatRenameAction(chatAction)
  const isDeleteAction = getIsGretaAIChatDeleteAction(chatAction)

  return (
    <>
      {isRenameAction ? (
        <GretaAIChatRenameModal
          chat={chatAction.chat}
          onCancel={onCloseChatAction}
          onSubmit={onConfirmRenameChat}
        />
      ) : null}
      {isDeleteAction ? (
        <GretaAIChatDeleteConfirmation
          onCancel={onCloseChatAction}
          onConfirm={onConfirmDeleteChat}
        />
      ) : null}
    </>
  )
}

export default GretaAIChatPanelChatAction
